import { Toggle } from "~/components/Toggle";

// // // //

/**
 * StackedControls - Toggle control for showing the % of total
 * @param props.value - The current value of the stacked control
 * @param props.onToggle - The function to call when the stacked control is toggled
 */
export function StackedControls(props: {
    value: boolean;
    onToggle: () => void;
}) {
    const { value, onToggle } = props;

    return (
        <div className="flex items-center gap-2">
            <p className="text-sm font-semibold text-foreground whitespace-nowrap select-none">
                Show % of Total
            </p>
            <Toggle
                checked={value}
                size="md"
                color="blue"
                onChange={() => {
                    onToggle();
                }}
            />
        </div>
    );
}
